import { Injectable } from '@angular/core';
import { AitTransporte } from '@tivic-team/manager-ts/dist/mob';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { Fase } from '@tivic-team/manager-ts/dist/ptc/entities/fase.entity';
import { ApiController } from 'app/controllers/api-controller.interface';
import { AitTransporteImagemDTO } from 'app/model/dtos/mob/ait-transporte-imagem.dto';
import { AitTransporteDTO, AitTransporteListDTO } from 'app/model/dtos/mob/ait-transporte.dto';
import { RecursoDTO } from 'app/model/dtos/mob/recurso.dto';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environment-v3';

@Injectable()
export class AitTransporteController implements ApiController<AitTransporte> {

  constructor() { }
  get(...args: number[]): Promise<AitTransporte> {
    throw new Error('Method not implemented.');
  }
  create(entity: AitTransporte): Promise<AitTransporte> {
    throw new Error('Method not implemented.');
  }
  update(entity: AitTransporte): Promise<AitTransporte> {
    throw new Error('Method not implemented.');
  }

async find(filtros?: IFilter): Promise<AitTransporte[]>{
    let quark = new Quark(
        new HttpGet({
            url: new Url({
                id: 'mob/relatoriourbano/localinfracao',
                environment: environmentv3,
                filter: filtros
            }),
        }),
        new HttpResponse(
            new Array<AitTransporte>()
        )
    );
    return await quark.call();
}

  async findAitColetivoUrbano(filtros?: IFilter): Promise<AitTransporteListDTO> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/aits',
          environment: environment,
          filter: filtros
        }),
      }),
      new HttpResponse(
        new AitTransporteListDTO()
      )
    );
    return await quark.call();
  }

  getAit(cdAit: number): Promise<AitTransporteDTO> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/aits/:cdAit',
          environment: environment,
          pathParams: new JSONData({ cdAit: cdAit })
        }),
      }),
      new HttpResponse(
        new AitTransporteDTO
      )
    );
    return quark.call();
  }

  async getFaseByAit(cdAit: number): Promise<Fase> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/aits/fase/:cdAit',
          environment: environment,
          pathParams: new JSONData({ cdAit: cdAit })
        }),
      }),
      new HttpResponse(
        new Fase
      )
    );
    return await quark.call();
  }

  async getAllRecursos(cdAit: number): Promise<RecursoDTO[]> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/aits/:cdAit/recursos',
          environment: environment,
          pathParams: new JSONData({ cdAit: cdAit })
        }),
      }),
      new HttpResponse(
        new Array<RecursoDTO>()
      )
    );
    return await quark.call();
  }

  async getRecurso(cdAit: number, cdDocumento: number): Promise<RecursoDTO[]> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/aits/:cdAit/recursos/:cdDocumento',
          environment: environment,
          pathParams: new JSONData({ cdAit: cdAit, cdDocumento: cdDocumento })
        }),
      }),
      new HttpResponse(
        new Array<RecursoDTO>()
      )
    );
    return await quark.call();
  }

  async createAitTransporte(ait: AitTransporteDTO): Promise<AitTransporteDTO> {
    let quark = new Quark(
      new HttpPost({
        url: new Url({
          id: 'mob/aits',
          environment: environment,
        }),
        data: new JSONData(ait)
      }),
      new HttpResponse(
        new AitTransporteDTO()
      )
    );
    return await quark.call();
  }

  async updateAitTransporte(ait: AitTransporteDTO): Promise<AitTransporteDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
          id: 'mob/aits/:cdAit',
          environment: environment,
          pathParams: new JSONData({ cdAit: ait.cdAit })
        }),
        data: new JSONData(ait)
      }),
      new HttpResponse(
        new AitTransporteDTO()
      )
    );
    return await quark.call();
  }

  async getConcessaoByPermissionario(cdPessoa: number): Promise<Concessao> {
    let quark = new Quark(
      new HttpGet({
        url: new Url({
          id: 'mob/concessaocoletivourbano/concessao/:cdPessoa',
          environment: environmentv3,
          pathParams: new JSONData({ cdPessoa: cdPessoa })
        }),
      }),
      new HttpResponse(
        new Concessao()
      )
    );
    return await quark.call();
  }

  async getImagens(cdAit: number): Promise<Array<AitTransporteImagemDTO>> {
    let quark = new Quark(
        new HttpGet({
            url: new Url({
                id: "mob/aits/imagens/:cdAit",
                environment: environment,
                pathParams: new JSONData({
                    cdAit: cdAit,
                }),
            }),
        }),
        new HttpResponse(new Array<AitTransporteImagemDTO>())
    );
    return await quark.call();
}
}